import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';

function MarketingNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/features', label: 'Features' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/demo', label: 'Demo' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className="marketing-navbar">
      <div className="marketing-nav-container">
        <Link to="/" className="marketing-nav-brand">
          <img
            src="/images/deedstack-logos/logo-horizontal-final.svg"
            alt="DeedStack™"
            className="marketing-nav-logo"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="marketing-nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`marketing-nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/signup" className="btn marketing-nav-cta">
            Start Free Trial
          </Link>

          {/* Marketing visitors have no account, so this persists to
              localStorage only. */}
          <ThemeToggle />
        </div>

        {/* Mobile Menu Button */}
        <button
          className="marketing-mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="marketing-mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`marketing-mobile-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/signup"
            className="btn marketing-mobile-cta"
            onClick={() => setMobileMenuOpen(false)}
          >
            Start Free Trial
          </Link>

          {/* Labelled here: the mobile menu has room for words, and the icons
              alone are harder to read in a vertical stack. */}
          <ThemeToggle className="theme-toggle-labelled" />
        </div>
      )}
    </nav>
  );
}

export default MarketingNavbar;
